export const TERMINATED_CLIENT_ERROR = { value: "terminated_client_error", error: "terminatedClientModification" };
export const ARCHIVED_MEMBER_ERROR = { value: "archived_member_error", error: "membersArchivedModification" };
export const ARCHIVED_CLIENT_ERROR = { value: "archived_client_error", error: "clientArchivedModification" };
export const ARCHIVED_DIVISION_ERROR = { value: "archived_division_error", error: "divisionArchivedModification" };
export const ARCHIVED_CLASS_ERROR = { value: "archived_class_error", error: "classArchivedModification" };
export const ARCHIVED_DEPENDENT_PERSON_ERROR = { value: "archived_dependent_person_error", error: "dependentPersonArchivedModification" };
export const NO_PREVIOUS_COVERAGE = { value: "no_previous_coverage", error: "noPreviousCoverageForRole" };

export const SIMPLE_FETCH_ERRORS = [TERMINATED_CLIENT_ERROR.value,
ARCHIVED_MEMBER_ERROR.value,
ARCHIVED_CLIENT_ERROR.value,
ARCHIVED_DIVISION_ERROR.value,
ARCHIVED_CLASS_ERROR.value,
ARCHIVED_DEPENDENT_PERSON_ERROR.value,
NO_PREVIOUS_COVERAGE.value]


// WEBPACK FOOTER //
// ./src/components/common/enums/simpleFetchErrorType.js